import { type UseMutationOptions, useMutation } from '@tanstack/react-query';
import { type AxiosError } from 'axios';

import {
  type CreateTagRequest,
  type CreateTagResponse,
  InterviewService,
} from '@/services/api';

export const useGenerateAndGetInterviewQuestionTagsMutation = (
  options?: UseMutationOptions<Array<string>, AxiosError, CreateTagRequest>
) => {
  return useMutation<Array<string>, AxiosError, CreateTagRequest>({
    mutationFn: async (body) => {
      const createResponse = await InterviewService.postInterviewsTags({
        body,
      });

      // Poll the results using the requestId until isWaiting is false
      let pollResponse: CreateTagResponse;
      do {
        pollResponse = await InterviewService.getInterviewsTags({
          requestId: createResponse,
        });

        if (pollResponse.isWaiting) {
          await new Promise((resolve) => setTimeout(resolve, 1000)); // wait for 1 second before polling again
        }
      } while (pollResponse.isWaiting);

      // Return the final list of AI tags
      return pollResponse.data ?? [];
    },
    ...options,
  });
};
